import { AsyncThunk, createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { filterTableDataAPI } from "services/CRUDServices"

export const filterCancelDriverAllocate: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "driver-allocate-cancel",
  async (body: any) => {
    // delete body.pageNumber
    const data = await filterTableDataAPI(
      "/resource-api/freelancerShiftReservation/v1/s3/cancelShiftFilter",
      body.pageNumber,
      { ...body, pageNumber: undefined, pageSize: undefined },
      true,
      body.pageSize || 10,
      false
    )
    return data.data.response
  }
)

const initialState: any = {
  driverDetail: [],
  fetchpost: false,
  errorMessage: null,
  isUpdating: false,
  filter: {},
}

const DriverCancelAllocateSlice = createSlice({
  initialState: initialState,
  name: "driver-allocate-cancel",
  reducers: {

    setCancelShiftFilter: (state, action) => {
      state.filter = action.payload
    },

  },
  extraReducers: {
    [filterCancelDriverAllocate.fulfilled as any]: (state, action) => {
      state.driverDetail = action.payload
      state.fetchpost = false
    },
    [filterCancelDriverAllocate.pending as any]: (state) => {
      state.fetchpost = true
    },
    [filterCancelDriverAllocate.rejected as any]: (state) => {
      state.fetchpost = false
      state.errorMessage = "wrong"
    },
  },
})

export const { setCancelShiftFilter } =
  DriverCancelAllocateSlice.actions
export default DriverCancelAllocateSlice.reducer